import { GET_INFLATORS_INVENTORY } from '../actions/types';
export default function (state = false, action) {
    switch (action.type) {
        case GET_INFLATORS_INVENTORY:
            return action.payload;
        default:
            return state;
    }
}